<template>
  <div class="content my-0 py-1">
    <div class="container-fluid">
      <div class="row">
          <div class="col-12  mb-4 py-0">
            <h4 class="m-0 p-0 text-secondary">Pengaturan surat pemberitahuan</h4>
          </div>
          <div class="row">
            <div class="col-12 col-md-6 col-lg-4 mt-2" v-for="(item,index) in ReminderLetters" v-bind:key="'item'+item.id">
              <b-card>
                <b-list-group flush>
                  <b-list-group-item class="bg-light"><h5 style="margin:0;">{{ translateNotificationTarget(item.notification_target) }}</h5>
                    <small><b-badge pill variant="secondary">{{ item.type }}</b-badge></small>
                  </b-list-group-item>
                  <b-list-group-item>
                    <h5 style="margin:0;">Periode :</h5>
                    <smart-select name="period" :options="statusTypeOptions" usedefault :default-value="translatePeriod(item.period)" v-on:update="(value)=>{updateType(value,index)}">

                    </smart-select>
                  </b-list-group-item>
                  <b-list-group-item><button class="btn btn-primary" type="button" v-on:click="!saving?saveListing(index):''"><span v-if="saving && savingIndex == index" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>Ubah</button></b-list-group-item>
                </b-list-group>
              </b-card>
            </div>
          </div>
          <!-- <div class="col-12  my-2 py-0">
            <h5 class="m-0 p-0 text-secondary">Notifikasi perpanjangan</h5>
            <div class="row mt-1">
              <div class="col-12 col-md-6 col-lg-3 mt-2">
                <label class="d-block">Notification Target <span style="color:red;">*</span></label>
                <div class="form-control w-100 rounded"></div>
              </div>
              <div class="col-12 col-md-6 col-lg-3 mt-2">
                <label class="d-block">Type <span style="color:red;">*</span></label>
                <div class="form-control w-100 rounded"></div>
              </div>
              <div class="col-12 col-md-6 col-lg-3 mt-2">
                <label class="d-block">Periode <span style="color:red;">*</span></label>
                <smart-select name="type" :options="statusTypeOptions" v-on:update="updateNewIiStatus"></smart-select>
              </div>
              <div class="col-12 col-md-6 col-lg-3 my-2 d-flex align-items-end">
                <button class="btn btn-primary" type="button" v-on:click="saveListing"><span v-if="saving" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>Submit</button>
              </div>
            </div>
            <hr class="my-4">

            <h5 class="m-0 p-0 text-secondary">Notifikasi masa tenggang</h5>
            <div class="row mt-1">
              <div class="col-12 col-md-6 col-lg-3 mt-2">
                <label class="d-block">Notification Target <span style="color:red;">*</span></label>
                <div class="form-control w-100 rounded"></div>
              </div>
              <div class="col-12 col-md-6 col-lg-3 mt-2">
                <label class="d-block">Type <span style="color:red;">*</span></label>
                <div class="form-control w-100 rounded"></div>
              </div>
              <div class="col-12 col-md-6 col-lg-3 mt-2">
                <label class="d-block">Periode <span style="color:red;">*</span></label>
                <smart-select name="type" :options="statusTypeOptions" v-on:update="updateNewIiStatus"></smart-select>
              </div>
              <div class="col-12 col-md-6 col-lg-3 my-2 d-flex align-items-end">
                <button class="btn btn-primary" type="button" v-on:click="saveListing"><span v-if="saving" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>Submit</button>
              </div>
            </div>
            <hr class="my-4">

            <h5 class="m-0 p-0 text-secondary">Notifikasi tidak aktif</h5>
            <div class="row mt-1">
              <div class="col-12 col-md-6 col-lg-3 mt-2">
                <label class="d-block">Notification Target <span style="color:red;">*</span></label>
                <div class="form-control w-100 rounded"></div>
              </div>
              <div class="col-12 col-md-6 col-lg-3 mt-2">
                <label class="d-block">Type <span style="color:red;">*</span></label>
                <div class="form-control w-100 rounded"></div>
              </div>
              <div class="col-12 col-md-6 col-lg-3 mt-2">
                <label class="d-block">Periode <span style="color:red;">*</span></label>
                <smart-select name="type" :options="statusTypeOptions" v-on:update="updateNewIiStatus"></smart-select>
              </div>
              <div class="col-12 col-md-6 col-lg-3 my-2 d-flex align-items-end">
                <button class="btn btn-primary" type="button" v-on:click="saveListing"><span v-if="saving" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>Submit</button>
              </div>
            </div>
            <hr class="my-4">

          </div> -->
            <!-- <datatable :datas="ReminderLetters" :structure="TableStructure" :init="loadData" use-seeker seeker-url="/api/notification/settings" @searching="(val)=>!val.status?getReminderLetters():ReminderLetters=val.data">
              <template #customcell={obj,index}>
                    <td v-if="isMobile" class="py-3">
                        <ul style="list-style:none;width:100%;padding:0" class="rounded shadow bg-white p-2">
                            <li class="mt-2">
                                <div class="text-left mx-3 pt-0">
                                  <small class="my-0 py-0">Notification Target:</small>
                                  <br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.notification_target }}</b>
                                </div>
                                <hr class="my-1">
                                <div class="text-left mx-3 pt-0">
                                  <small class="my-0 py-0">Type:</small>
                                  <br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.type }}</b>
                                </div>
                                <div class="text-left mx-3 pt-0">
                                  <small class="my-0 py-0">Periode:</small>
                                  <br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.period }}</b>
                                </div>
                                <div class="text-left mx-3 pt-0">
                                  <b-button v-b-modal.modal-edit-application class="btn btn-info mr-2" v-on:click="selectedApplication=index;dataEdit=Object.assign({},obj)"><b-icon icon="pencil-square"></b-icon></b-button>
                                  <b-button v-b-modal.modal-delete v-on:click="deleteId=obj.id;itemToDelete=obj" class="btn btn-danger"><b-icon icon="trash"></b-icon></b-button>
                                </div>
                            </li>
                        </ul>
                    </td>
                    <td v-if="!isMobile" >{{ index+ 1 }}</td>
                    <td v-if="!isMobile" >{{ obj.notification_target }}</td>
                    <td v-if="!isMobile" >{{ obj.type }}</td>
                    <td v-if="!isMobile" >{{ obj.period }}</td>
                    <td v-if="!isMobile" >
                      <b-button v-b-modal.modal-edit-application class="btn btn-info mr-2" v-on:click="selectedApplication=index;dataEdit=Object.assign({},obj)"><b-icon icon="pencil-square"></b-icon></b-button>
                      <b-button v-b-modal.modal-delete v-on:click="deleteId=obj.id;itemToDelete=obj" class="btn btn-danger"><b-icon icon="trash"></b-icon></b-button>
                    </td>
                </template>
            </datatable> -->
          
      </div>
    </div>
  </div>
</template>
<script>
//   import ChartCard from 'src/components/Cards/ChartCard.vue'
//   import StatsCard from 'src/components/Cards/StatsCard.vue'
//   import LTable from 'src/components/Table.vue'
    import * as axios from 'axios';
    import Datatable from '../../components/Datatable.vue';
    import SmartSelect from '../../components/SmartSelect.vue';
    export default {
        components: {
        //   LTable,
        //   ChartCard,
        //   StatsCard
            'datatable':Datatable,
            'smart-select':SmartSelect
        },
        data () {
            return {
                errorList:[],
                saving:false,
                savingIndex:-1,
                selectedReminder:0,
                reminders:[],
                isMobile:false,
                loadData:true,
                ReminderLetters:[],
                searchValue:'',
                TableStructure:[
                  {label:'No',key:null},
                  {label:'Notification Target',key:null},
                  {label:'Type',key:null},
                  {label:'Periode',key:null},
                  {label:'Tindakan',key:null},
                ],
                statusTypeOptions:[
                    {label:'Satu kali',value:'once'},
                    {label:'Dua kali seminggu',value:'2AW'},
                    {label:'Tiga kali seminggu',value:'3AW'},
                    {label:'Empat kali seminggu',value:'4AW'},
                    {label:'Setiap hari',value:'daily'},
                    {label:'Seminggu sekali',value:'weekly'},
                    {label:'Dua minggu sekali',value:'2week'},
                ],
                newType:{
                  period:''
                }
            }
        },
        created(){
            this.$reActivateAccess(this) /*SETTIMEOUT LOGOUT OTOMATIS, (this,true) UTK MELIHAT DETIK DI BROWSHER*/
            this.getReminderLetters();
        },
        methods:{
          translateNotificationTarget(notification_target){
            var label="";
            switch(notification_target){
              case "airtime_notification":
                label = "Notifikasi perpanjangan";
                break;
              case "pre_nonactive_notification_notification":
                label = "Notifikasi masa tenggang";
                break;
              case "nonactive_notification_notification":
                label = "Notifikasi tidak aktif";
                break;
            }
            return label;
          },
          translatePeriod(period){
            var label="";
            switch(period){
              case "once":
                label = "Satu kali";
                break;
              case "2AW":
                label = "Dua kali seminggu";
                break;
              case "3AW":
                label = "Tiga kali seminggu";
                break;
              case "4AW":
                label = "Empat kali seminggu";
                break;
              case "daily":
                label = "Setiap hari";
                break;
              case "weekly":
                label = "Seminggu sekali";
                break;
              case "2week":
                label = "Dua minggu sekali";
                break;
            }
            return label;
          },
            updateType(data,index){
              this.ReminderLetters[index].period=data
              
            },
            getReminderLetters(url=(this.$baseUrl+'/api/notification/settings')){
              this.loadData=true
              axios.get(url,{'headers':{
                      'Authorization':'Bearer '+localStorage.getItem('accessToken')
                  }
              }).then((result)=>{
                  console.log(result)
                  console.log(result.data)
                  this.ReminderLetters = result.data;
                  this.loadData=false
              }).catch((err)=>{
          //check if token fail
          if(err.response && err.response.status==401){
            localStorage.removeItem('accessToken')
          this.$router.push('/login')
          }
                  console.log(err)
                  this.loadData=false
              })
            },
            saveListing(index){
              this.savingIndex = index
                this.saving=true
                console.log('updating index: '+index)
                axios.post(this.$baseUrl+'/api/notification/settings', this.ReminderLetters[index],
                {
                    'headers':
                    {
                        'Authorization':'Bearer '+localStorage.getItem('accessToken')
                    }
                }).then((result)=>{
                  this.saving=false
                    console.log(result)
                    // this.ReminderLetters = result.data.data;
                    // this.saving=false
                    this.getReminderLetters()

                }).catch((err)=>{
          //check if token fail
          if(err.response && err.response.status==401){
            localStorage.removeItem('accessToken')
          this.$router.push('/login')
          }
                    console.log(err.response)
                    this.errorList=[]
                    this.errorList=Object.values(err.response.data.errors)
                    console.log(this.errorList)
                    this.saving=false
                })
            }
        }
    }
</script>
<style scoped>
::v-deep .btn {
    padding : 2px 6px;
}

@media (min-width: 1200px) { 
  .card .card-body {
    width: 250px;
  }
} 
</style>
